import { Grid, Link, Breadcrumbs } from "@mui/material";
import React, { useEffect } from "react";
import moduleLayoutStyles from "./Styles/moduleLayout.module.css";
import reportGenModule from "../../images/reportGenModule.svg";
import Analyze from "../../images/Analyze.svg";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../Hooks/stateProvider";
import { ls } from "../../variables";
import greenNoteLogo from "../../images/greennote.svg";
import dashboardLogo from "../../images/dashboard.svg";

const GeneralModuleLayout = () => {
  const navigate = useNavigate();
  const [{ moduleType }, dispatch] = useStateValue();
  let onHandler = (value) => {
    if (value == "/app/hytrLayout"){
      dispatch({ type: "moduleType", moduleType: "HYTR" });
    }
    navigate(value);
  };

  const reportType = ls.get("reportType");

  useEffect(() => {
    dispatch({ type: "fy_year", fy_year: "" });
    dispatch({ type: "quarter", quarter: "" });
    dispatch({ type: "half_year", half_year: "" });
    dispatch({ type: "fundname", fundname: "" });
  }, []);
  const userType = ls.get("userType");

  return (
    <div>
      <Grid container className={moduleLayoutStyles.mainContent}>
        <div className={moduleLayoutStyles.navBody}>
          <Grid container spacing={1} display="flex">
            <Grid item sm={12}>
              {userType == "SEBI" && <Breadcrumbs
                className={moduleLayoutStyles.historyNav}
                aria-label="breadcrumb"
              >
                <Link
                  underline="hover"
                  color="inherit"
                  onClick={() => navigate("/app/welcome")}
                >
                  Welcome
                </Link>
              </Breadcrumbs>}
            </Grid>
          </Grid>
        </div>
        <Grid
          item
          xs={12}
          className={moduleLayoutStyles.welcomeContent}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1 style={{ margin: "1rem" }}>General Module</h1>
        </Grid>
        <Grid
          item
          lg={4}
          xs={12}
          sm={6}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            alignItems: "center",
          }}
          onClick={() => onHandler("/app/Dashboard")}
        >
          <div className={moduleLayoutStyles.boxContainer}>
            <img
              src={dashboardLogo}
              alt="Dashboard Logo"
              className={moduleLayoutStyles.moduleImg}
            />
            <h3 className={moduleLayoutStyles.moduleName}>Dashboard</h3>
          </div>
        </Grid>
        <Grid
          item
          lg={4}
          xs={12}
          sm={6}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            alignItems: "center",
          }}
          onClick={() => onHandler("/app/greenNote")}
        >
          {/* <LightTooltip title={!reportType['quicksight']?.length>0 ? "You do not have access to Report Generator. Please contact Admin." : ""} placement="top"> */}
          <div className={moduleLayoutStyles.boxContainer}>
            <img
              src={greenNoteLogo}
              alt="General Module Logo"
              className={moduleLayoutStyles.moduleImg}
            />
            <h3 className={moduleLayoutStyles.moduleName}>Green Note</h3>
          </div>
          {/* </LightTooltip> */}
        </Grid>
        <Grid
          item
          lg={4}
          xs={12}
          sm={6}
          md={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            alignItems: "center",
          }}
          onClick={() => onHandler("/app/ReportGenModule")}
        >
          <div className={moduleLayoutStyles.boxContainer}>
            <img
              src={reportGenModule}
              alt="Report Generator Module Logo"
              className={moduleLayoutStyles.moduleImg}
            />
            <h3 className={moduleLayoutStyles.moduleName}>Report Generator</h3>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default GeneralModuleLayout;
